export enum TaskPurpose {
  'overlaps' = 'overlaps',
  'companyMap' = 'companyMap',
  'google' = 'google',
  'linkedin' = 'linkedin',
  'review' = 'review',
  'addMembers' = 'addMembers',
}
